
import { LogEntry } from "@/api/dtos/LogEntry.schema";
import { LogEventType } from "@/api/dtos/LogEventType.schema";
import { StationSummary } from "@/api/dtos/StationSummary.schema";
import { eventTypeToGerman, logEntryToGerman } from "@/misc/i18n";
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DateRangePicker from "../DateRangePicker.vue";
import LogList from "./LogList.vue";
import LogEntryPanel from "./panels/LogEntryPanel.vue";

@Component({
  components: {
    DateRangePicker,
    LogEntryPanel,
    LogList,
  },
})
export default class DetailedLog extends Vue {
  @Prop()
  readonly logEntries!: LogEntry[];

  @Prop()
  readonly filterEventTypes!: LogEventType[];

  @Prop()
  readonly stations!: StationSummary[];

  queryDates: [Date, Date] | null = null;
  selectedLogEntry: LogEntry | null = null;
  queryLogTypes: LogEventType[] = [];
  queryStations: StationSummary[] = [];

  eventTypeToGerman = eventTypeToGerman;
  logEntryToGerman = logEntryToGerman;
  moment = moment;

  mounted(): void {
    const query = this.$route.query as { [k: string]: string };
    // TODO evaluate query params
    // if (!query) return
    // if (query.stations) {
    //   this.queryStations = this.stringToArray(query.stations)
    // }
    // if (query.logTypes) {
    //   this.queryLogTypes = this.stringToArray(query.logTypes)
    // }
    // if (query.dates) {
    //   this.queryDates = this.stringToArray(query.dates)
    // }
  }

  @Watch("queryDates")
  @Watch("queryLogTypes")
  @Watch("queryStations")
  onFilterChanged(): void {
    this.$emit("query", {
      dateRange: this.queryDates,
      stations: this.queryStations,
      eventTypes: this.queryLogTypes,
    });
  }

  onLogTypeClicked(logType: LogEventType): void {
    const i = this.queryLogTypes.findIndex((x) => x === logType);
    if (i < 0) this.queryLogTypes.push(logType);
    else this.queryLogTypes.splice(i, 1);
  }

  onDateRangePicked(range: [Date, Date]): void {
    this.queryDates = range;
  }

  onLogEntryClicked(logEntry: LogEntry): void {
    this.selectedLogEntry = logEntry;
  }

  stringToArray(input: string): string[] {
    return input.split(",");
  }

  arrayToString(input: string[]): string {
    return input.join(",");
  }

  get selectItems(): {
    text: string;
    value: StationSummary;
  }[] {
    return this.stations.map((s) => {
      return { text: s.stationLocation.stationName, value: s };
    });
  }
}
